/**
 * Extracts initials from a name string
 * @param name - Full name (e.g., "Warren Lovell")
 * @returns Uppercase initials (e.g., "WL"), max 2 characters
 */
export function getInitials(name?: string | null): string {
  if (!name || name.trim() === '') {
    return '?';
  }

  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    // Single name: take first two characters or just first if only one char
    return words[0].substring(0, 2).toUpperCase();
  }

  // Multiple words: take first letter of first and last word
  const firstInitial = words[0].charAt(0);
  const lastInitial = words[words.length - 1].charAt(0);

  return (firstInitial + lastInitial).toUpperCase();
}

/**
 * Generates a consistent color based on a string (name or email)
 * Returns a hue value for HSL color
 */
export function getAvatarColorHue(identifier?: string | null): number {
  if (!identifier) return 150; // Default green hue

  // Simple hash to generate consistent color
  let hash = 0;

  for (let i = 0; i < identifier.length; i++) {
    hash = (identifier.charCodeAt(i) + hash * 31) & 0xffffffff;
  }

  // Return hue between 0-360
  return Math.abs(hash) % 360;
}
